<div class="center">
  <form [formGroup]="subscriptionFormGroup" class="flex-col width-800">
    <h2 class="center margin-y-10">
      Create new subscription rules
    </h2>

    <div class="flex-row margin-y-10" *ngIf="context && context.skipServiceHierarchy">
      <label class="width-50 font-20 bold">Mode services:</label>
      <div class="flex-grow font-20 margin-l-10">
        Applicable for all services in this mode
        <div>{{ modeServicesText }}</div>
      </div>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Name:</label>
      <input formControlName="ruleName" name="ruleName" placeholder="Rule Name" class="flex-grow font-20 margin-l-10" />
    </div>

    <div class="flex-row margin-y-10" *ngIf="!context">
      <label class="width-50 font-20 bold">City:</label>
      <ng-select formControlName="city" name="city" placeholder="Select city" class="flex-grow font-20 margin-l-10">
        <ng-option *ngFor="let item of cities" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10" *ngIf="!context || !context.skipServiceHierarchy">
      <label class="width-50 font-20 bold">Services:</label>
      <ng-select formControlName="services" name="services" placeholder="Select services" (change)="validateAndGetModeForServices();"
        class="flex-grow font-20 margin-l-10" [multiple]=true>
        <ng-option *ngFor="let item of services" [value]="item">{{item.name}}{{item.active === false ? ' (inactive)' : ''}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Target Segment:</label>
      <div class="flex-grow font-20 margin-l-10 target-segment">
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'userSelectors'" formControlName="targetSegment">
          <span>User Selector</span>
        </label>
        <label class="font-20" *ngIf="showQualityFeedbackSegment">
          <input type="radio" name="targetSegment" [value]="'qualityFeedback'" formControlName="targetSegment">
          <span>Quality Feedback</span>
        </label>
        <label class="font-20" *ngIf="showEntireCitySegment">
          <input type="radio" name="targetSegment" [value]="'entireCity'" formControlName="targetSegment">
          <span>Entire City (default subscription)</span>
        </label>
        <label class="font-20" *ngIf="showHHSegment">
          <input type="radio" name="targetSegment" [value]="'HH'" formControlName="targetSegment">
          <span>HH</span>
        </label>
        <label class="font-20" *ngIf="showMCSegment">
          <input type="radio" name="targetSegment" [value]="'MC'" formControlName="targetSegment">
          <span>MC</span>
        </label>
      </div>
    </div>

    <div class="flex-row margin-y-10" *ngIf="showBlockOrders">
      <label class="width-50 font-20 bold"></label>
      <mat-checkbox formControlName="suspendServicesPostExpiry" class="flex-grow font-20 margin-l-10" color="primary">
        Block Orders Post Expiry
      </mat-checkbox>
    </div>


    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Purchase Start Date:</label>
      <p-calendar formControlName="startDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="startDate"
        [showIcon]=true dateFormat="d/m/yy" (ngModelChange)="changeInDate()" [minDate]="today" [defaultDate]="today"
        [maxDate]="maxStartDate" [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Purchase End Date:</label>
      <p-calendar formControlName="endDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="endDate"
        [defaultDate]="tomorrowEod" [showIcon]=true dateFormat="d/m/yy" (ngModelChange)="changeInDate()"
        [selectOtherMonths]="true" showTime="true" hourFormat="24" [showButtonBar]="true" [minDate]="minEndDate"
        [stepMinute]="30">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Subscription Priority:</label>
      <input formControlName="priority" class="flex-grow font-20 margin-l-10" name="priority" type="number" />
    </div>


    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Rule Type</label>
      <ng-select formControlName="ruleType" name="ruleType" placeholder="Select Rule Type" [multiple]=false
        class="flex-grow font-20 margin-l-10" [disabled]="isRuleTypeLocked">
        <ng-option *ngFor="let type of eligibleRuleTypes" [value]="type">{{ruleTypeLabel(type)}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10" *ngIf="formValue('ruleType') == 'variableCommission'">
      <label class="font-20 bold margin-r-10">Commission Discount Percent</label>
      <input formControlName="ruleValue" class="flex-grow font-20 margin-l-10" name="ruleValue" type="number"
        pTooltip="Enter commission discount percent" />
    </div>

    <div class="flex-row margin-y-10" *ngIf="selectedSubscriptionType !== 'CASHBACK'">
      <label class="width-50 font-20 bold">User Selector:</label>
      <ng-select formControlName="userSelector" name="userSelector" placeholder="Select User Selector"
        class="flex-grow font-20 margin-l-10">
        <ng-option *ngFor="let item of userSelectors" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div *ngIf="showFeedbackFields">
      <div *ngIf="feedbackContextsLoading">Loading feedback contexts…</div>
      <div *ngIf="feedbackContextsError">
        Could not load feedback contexts.
        <button type="button" mat-button (click)="loadFeedbackContexts()">Retry</button>
      </div>
      <div *ngFor="let entry of feedbackScoreApplicability.controls; let i = index" class="margin-y-10">
        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Feedback Context:</label>
          <ng-select [formControl]="entry.get('context')" placeholder="Select feedback context"
            class="flex-grow font-20 margin-l-10" [loading]="feedbackContextsLoading">
            <ng-option *ngFor="let context of feedbackContexts" [value]="context">{{context}}</ng-option>
          </ng-select>
        </div>
        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Min Ratio:</label>
          <input [formControl]="entry.get('minValue')" type="number" min="0" max="1" step="0.01"
            class="flex-grow font-20 margin-l-10" />
        </div>
        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Max Ratio:</label>
          <input [formControl]="entry.get('maxValue')" type="number" min="0" max="1" step="0.01"
            class="flex-grow font-20 margin-l-10" />
        </div>
        <button type="button" mat-button *ngIf="feedbackScoreApplicability.length > 1"
          (click)="removeFeedbackEntry(i)">Remove context</button>
      </div>
      <button type="button" mat-button (click)="addFeedbackEntry()">Add feedback context</button>
    </div>

    <div class="flex-row margin-y-10">
      <label class="font-20 bold">Exclude captains from these Incentives</label>
      <ng-select formControlName="excludeIncentiveTypes" name="excludeIncentiveTypes" placeholder="Select types"
        [multiple]=true class="flex-grow font-20 margin-l-10">
        <ng-option *ngFor="let incentiveType of incentiveTypes"
          [value]="incentiveType">{{incentiveTypesMap[incentiveType]}}</ng-option>
      </ng-select>
    </div>

    <div *ngFor="let rule of formValue('rules') || []; let i = index">

      <label class="width-50 font-20 bold">Rule {{i+1}}:</label>
      <button mat-stroked-button (click)="deleteRule(i)" [disabled]="formValue('rules').length === 1" color="warn"
        class="right-align">
        <mat-icon>delete</mat-icon>
      </button>

      <div class="margin-l-50">
        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Validity Type:</label>
          <ng-select [formControl]="rule.validityType" name="validityType" placeholder="Select validity type"
            class="flex-grow font-20 margin-l-10" (change)="validityTypeChanged(rule)">
            <ng-option *ngFor="let validityType of getValidityTypesForSelectedType()" [value]="validityType">{{validityType}}</ng-option>
          </ng-select>
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Rule title (Optional):</label>
          <ng-select [formControl]="rule.subscriptionTitle" name="s" placeholder="Select rule title"
            class="flex-grow font-20 margin-l-10">
            <ng-option *ngFor="let subscriptionTitle of subscriptionTitles" [value]="subscriptionTitle">{{subscriptionTitle}}</ng-option>
          </ng-select>
        </div>

        <div class="flex-row margin-y-10">
          <div class="width-50 font-20 flex-grow">
            <label class="width-50 font-20 bold"></label>
            <mat-checkbox [formControl]="rule.isRecommended" name="isRecommended" class="flex-grow font-20 margin-l-10" color="primary"> Is Recommended</mat-checkbox>
          </div>
        </div>

        <div class="flex-row margin-y-10" *ngIf="rule.validityType.value !== 'dapr'">
          <label class="width-50 font-20 bold">Max Value:</label>
          <input [formControl]="rule.maxValue" class="flex-grow font-20 margin-l-10 no-spinner" name="maxValue"
            type="number" min="1" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNonPositiveAmount($event, rule.maxValue)"
            (wheel)="$event.preventDefault()" />
        </div>

        <div class="flex-row margin-y-10" *ngIf="rule.validityType.value === 'dapr'">
          <label class="width-50 font-20 bold">Min Value:</label>
          <input [formControl]="rule.minValue" class="flex-grow font-20 margin-l-10" name="minValue" type="number" />
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Purchase Price:</label>
          <input [formControl]="rule.ruleAmount" class="flex-grow font-20 margin-l-10 no-spinner" name="ruleAmount"
            type="number" min="1" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNonPositiveAmount($event, rule.ruleAmount)"
            (wheel)="$event.preventDefault()" />
        </div>
        <div class="flex-row">
          <label class="width-50"></label>
          <span class="field-info margin-l-10">{{ taxInfoText }}</span>
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Original Price:</label>
          <input [formControl]="rule.strikedOutAmount" class="flex-grow font-20 margin-l-10 no-spinner"
            name="strikedOutAmount" type="number" min="1" (keydown)="blockInvalidNumberKeys($event)"
            (input)="rejectNonPositiveAmount($event, rule.strikedOutAmount)" (wheel)="$event.preventDefault()"
            pTooltip="Optional: Enter amount more than Purchase Price" />
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Period In Days:</label>
          <input [formControl]="rule.periodInDays" class="flex-grow font-20 margin-l-10" name="periodInDays"
            type="number" min="1" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            onpaste="return /^[1-9]\d*$/.test((event.clipboardData || window.clipboardData).getData('text'))" />
        </div>
      </div>

    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-stroked-button (click)="addRule()" [disabled]="formValue('rules') && formValue('rules').length === maxRulesAtOnce">
        <mat-icon>add</mat-icon>
        Add Rule
      </button>
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-raised-button class="btn-primary" (click)="createSubscriptionRules()"> Create Rules </button>
    </div>
  </form>
</div>
<app-toaster [config]="toasterService.toaster"></app-toaster>

<ng-template #OverlappingPriorityRuleAlert>
  <div *ngIf="formValue('isDefaultSubscription')">
    <h3 matDialogTitle>Already default subscription rules exists</h3>
  </div>
  <div *ngIf="formValue('isAutoAssignedToHH')">
    <h3 matDialogTitle>Already a higher priority HH rule exists</h3>
  </div>
  <div *ngIf="!formValue('isDefaultSubscription') && !formValue('isAutoAssignedToHH')">
    <h3 matDialogTitle>Overlapping Subscription Rules with same priority</h3>
  </div>
  <table class="table table-striped table-bordered outerTable">
    <thead>
      <tr>
        <th>Rule Id</th>
        <th>Rule name</th>
        <th>Priority</th>
        <th>Amount</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Period In Days</th>
        <th>Comission Type</th>
        <th>Validity Type</th>
        <th>Max Value</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rule of overlappingRules">
        <td class="displayStyle">
          <a [routerLink]="['/subscription/view', rule.id]" target="_blank" rel="noopener">{{rule.id}}</a>
        </td>
        <td class="displayStyle">{{rule.ruleName}}</td>
        <td class="displayStyle">{{rule.priority}}</td>
        <td class="displayStyle">{{rule.ruleAmount}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.startTime*1000)}}</td>
        <td class="displayStyle">{{Utils.dateFromEpoch(rule.endTime*1000)}}</td>
        <td class="displayStyle">{{rule.periodInDays}}</td>
        <td class="displayStyle">{{rule.ruleType}}</td>
        <td class="displayStyle">{{rule.validity && rule.validity.length > 0 ? rule.validity[0].type : "unlimited"}}</td>
        <td class="displayStyle">{{rule.validity && rule.validity.length > 0 ? rule.validity[0].maxValue : null}}</td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="formValue('isDefaultSubscription')">
    <span>Please deactivate default subscription first and then create a new one.</span>
  </div>
  <div *ngIf="formValue('isAutoAssignedToHH')">
    <span>Please create a higher priority rule.</span>
  </div>
  <div *ngIf="!formValue('isDefaultSubscription') && !formValue('isAutoAssignedToHH')">
    <span>Please create a Subscription Rule with other priority to proceed</span>
  </div>
  <div mat-dialog-actions class="button-flex" style="float:right;">
    <button mat-button matDialogClose>ok</button>
  </div>
</ng-template>
